const NewResourcePhone = () =>
  import('@/views/main/helper/newResourcePhone/NewResourcePhone.vue')
export default {
  path: '/main/helper/newResourcePhone',
  name: 'NewResourcePhone',
  component: NewResourcePhone
}
